import moment from "moment";
export default function mapClientDetailsToLookup(lookup, clientData) {    
  if (!lookup || !clientData || clientData.length == 0) {
        return clientData;
        //throw Error("Need lookup and clientData");
  }
  let {
    taskTypes  
  } = lookup;

    let allClients = clientData.map(client => {
        client.generationType = client.generationType?.trim();
        client.integrationStatus = client.isLinked == "Y" ? "Unlink" : "Link";
       // firstname
        client.firstName = client.firstName.replace("amp;", "").replace("&quot;", "\"");
    //taskType name
        let clientTaskType = taskTypes.find(task => client.primaryTask === task.id);
        client.primaryTaskName = clientTaskType ? clientTaskType.name : "";
        client.primaryTaskCode = clientTaskType ? clientTaskType.code : "";

    //Groups
        let clientGroupsList = client.groupName != null ? client.groupName.split(";").filter(function (value, index, arr) { return value != "None" && value != "NONE"; }) : [];
        let clientGroupsNumberList = client.groupNumber != null ? client.groupNumber.split(";") : [];
        
        let groupNameConcat = clientGroupsList            
            .map((d, i) => d?.trim() + (clientGroupsNumberList[i]?.trim().length > 0 ? (' - ' + clientGroupsNumberList[i]?.trim()) : ""))
            .join("|")
            .replace("amp;", "")
            .replace("&quot;", "\"")
            .replace("&nbsp;", "");
        
        client.groupName = groupNameConcat == null || groupNameConcat.length == 0 ? "NONE" : groupNameConcat;

        //client status
        client.active =
            client.active === "Y" ? "Active" : "Inactive";

        //fiscal year
        var tempFiscalYear = client.fiscalYear;
        if (tempFiscalYear.includes("01/01/1900") || tempFiscalYear.includes("01/01/1901") || tempFiscalYear.includes("1/1/1900") || tempFiscalYear.includes("1/1/1901")) {
            client.fiscalYear = "";
        }
        if (client.fiscalYear != "" && tempFiscalYear.trim().length > 0) {
            var dt = tempFiscalYear.split('/');
            if (dt.length <= 1) {
                dt = tempFiscalYear.split('-');
            }

            if (dt.length > 1) {
                client.fiscalYear = dt[0] + "/" + dt[1];
            }
        }


        return client;
  });

    return allClients;
}
